import Relay from 'react-relay';
/**
*  Update sport mutation
*/
export default class UpdateSportMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation{
      updateSport
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
      sport: {
        name: this.props.sport.name,
        logo: this.props.sport.logo,
        positions: this.props.sport.positions,
        certificates: this.props.sport.certificates,
        levels: this.props.sport.levels,
        status: this.props.sport.status,
      },
      sportID: this.props.sport.id,
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on updateSportPayload @relay(pattern: true){
        viewer {
          sports
        }
        edge{
          node
        }
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        viewer: this.props.viewer.id,
        edge :{
          node : this.props.sport.id,
        }
      },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
      }
    `,
  }
}


// WEBPACK FOOTER //
// ./src/mutations/Sport/UpdateSportMutation.js